export default "__VITE_ASSET__Ch_85DVG__"